import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import PropTypes from "prop-types";

export default function ComponentSelectMarksDialog({
  open,
  collegeId,
  clientId,
  courseRow,
  onClose,
  onConfirmMarks,
}) {
  const [components, setComponents] = React.useState([]);
  const [selected, setSelected] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  React.useEffect(() => {
    if (!open) return;

    const fetchComponents = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/exam-internal-component/${clientId}/${collegeId}`
        );

        setComponents(res.data.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    fetchComponents();
  }, [open, collegeId]);

  const handleConfirmMarks = () => {
    const component = components.find((c) => String(c.component_id) === String(selected));

    if (!component || !courseRow) return;

    onConfirmMarks(courseRow, component); // ✅ BOTH TOGETHER
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Select Internal Component</DialogTitle>

      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <TextField
            label="Component"
            name="component_id"
            select
            fullWidth
            value={selected}
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            onChange={(e) => {
              setSelected(e.target.value);
            }}
          >
            <option value="">Select Component</option>
            {components.map((c) => (
              <option key={c.component_id} value={c.component_id}>
                {c.component_name} (Max: {c.max_marks})
              </option>
            ))}
          </TextField>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={handleConfirmMarks}
          disabled={!selected}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(152, 152, 232, 0.1)" },
          }}
        >
          Download Marks
        </Button>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": { backgroundColor: "#1565c0", color: "#fff" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ComponentSelectMarksDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmMarks: PropTypes.func.isRequired,
  collegeId: PropTypes.number.isRequired,
  clientId: PropTypes.number.isRequired,
  courseRow: PropTypes.object,
};
